export default __webpack_public_path__ + "static/media/msp.3ac44ffd.png";